import { OverlayEvent } from "./overlay.types";

const DEFAULT_USER_COLOR = "#6b7280";
const TIME_OFF_COLOR = "#e63131";

const hexToRgba = (hex: string | undefined, alpha: number) => {
    const safeHex = hex && /^#([0-9a-fA-F]{6})$/.test(hex) ? hex : DEFAULT_USER_COLOR;
    const red = parseInt(safeHex.slice(1, 3), 16);
    const green = parseInt(safeHex.slice(3, 5), 16);
    const blue = parseInt(safeHex.slice(5, 7), 16);
    const rgba = `rgba(${red}, ${green}, ${blue}, ${alpha})`;
    return rgba;
};

const buildScheduleStyle = (event: OverlayEvent) => {
    const accentColor = event.userColor || DEFAULT_USER_COLOR;
    const style = {
        backgroundColor: hexToRgba(accentColor, 0.5),
        borderLeft: `2px solid ${accentColor}`,
        borderTop: "none",
        borderRight: "none",
        borderBottom: "none",
        color: "rgba(0, 0, 0, 0.55)",
        fontSize: "10px",
        padding: "2px 4px",
        pointerEvents: "none" as const,
    };
    return style;
};

const buildTimeOffStyle = () => {
    const baseColor = hexToRgba(TIME_OFF_COLOR, 0.5);
    const hatch = `repeating-linear-gradient(45deg, ${TIME_OFF_COLOR} 0 4px, transparent 4px 8px)`;
    const style = {
        backgroundColor: baseColor,
        backgroundImage: hatch,
        borderLeft: `2px solid ${TIME_OFF_COLOR}`,
        borderTop: "none",
        borderRight: "none",
        borderBottom: "none",
        color: "rgba(0, 0, 0, 0.65)",
        fontSize: "10px",
        padding: "2px 4px",
        pointerEvents: "none" as const,
    };
    return style;
};

export const overlayEventPropGetter = (event: OverlayEvent) => {
    const style = event.overlayType === "time_off" ? buildTimeOffStyle() : buildScheduleStyle(event);
    const result = { style };
    return result;
};
